import * as Yup from "yup";
import { useState, useLayoutEffect } from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { useFormikContext } from "formik";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { FormikDialog } from "../../../components/dialogs";
import FormikReferenceField from "../../../components/inputs/FormikReferenceField";
import FormikTextField from "../../../components/inputs/FormikTextField";

export const initialValues = {
  code: "",
  resident: "",
};

export const validationSchema = Yup.object().shape({
  code: Yup.string()
    .required(<FormattedMessage id="validation.message.required" />)
    .nullable(),
});

export function AssignInRowDialog(props) {
  const { entity, onClose, onSubmit, open, apiUrl, normalizeReceivedValues } =
    props;

  return (
    <FormikDialog
      open={open}
      dialogTitle={"修改分配手帶"}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      onClose={onClose}
      maxWidth="xs"
    >
      <AssignInRowForm
        entity={entity}
        normalizeReceivedValues={normalizeReceivedValues}
      />
    </FormikDialog>
  );
}

const AssignInRowForm = (props) => {
  const home = useSelector((state) => state.home);
  const { entity, apiUrl = "" } = props;
  const { initialValues, values, touched, errors, setFieldValue, resetForm } =
    useFormikContext();

  useLayoutEffect(() => {
    resetForm({ values: initialValues });
    if (entity) {
      resetForm({ values: { ...initialValues, ...entity } });
    } else {
      resetForm({ values: initialValues });
    }
  }, [entity]);

  return (
    <form>
      <Grid container spacing={2}>
        <Grid item sm={12} xs={12}>
          <Card variant="outlined" style={{ marginBottom: 15 }}>
            <CardContent>
              <Grid container spacing={2}>
                <Grid item sm={12} xs={12}>
                  <FormikTextField
                    disabled
                    required
                    label="手帶編號"
                    name="code"
                  />
                </Grid>
                <Grid item sm={12} xs={12}>
                  <FormikReferenceField
                    edit={entity ? true : false}
                    required
                    label="院友姓名"
                    name="resident"
                    apiUrl={
                      "/api/homes/" + home.home.id + "/residents/references"
                    }
                    apiParams={{
                      type: "WRIST",
                    }}
                    getOptionLabel={(option) =>
                      option.lastnameTc + option.firstnameTc
                    }
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </form>
  );
};
